import React, {useContext, useEffect, useState} from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Checkbox from "@mui/material/Checkbox";
import InputAdornment from '@mui/material/InputAdornment';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Input from '@mui/material/Input';
import { TextField } from "@mui/material";
import { AppContext } from "../../App";

export default function MemberEventTravel(props){

  const [checked, setChecked] = useState(false)

  const [memberTravel, setMemberTravel] = useState(
      {
        passengerName: props.name, 
        passengerDob: props.dob,
        passengerId: props.idNumber, 
        passengerPhone: props.phone,
        passengerEmail: props.email,
        passengerRole: props.role,
        departRoute: "", 
        departDate: "", 
        returnRoute: "",
        returnDate: "",
        prefTime: "",
        groundTravel: "",
        accom: ""
      }
  )

  const handleTextInput = (e) => {
    setMemberTravel({
      ...memberTravel,
      [e.target.name]: e.target.value
    })
  }

  const handleChange = () => {
    setChecked(prev=>!prev)
  }


  useEffect(() => {
    props.setTravelParty(
      props.travelParty.map((mem) => {
        return (mem.passengerName === props.name ? 
            memberTravel :
            mem)
        }
      )
    )
  }, [memberTravel])

  useEffect(()=> {
    props.setData(prev => ({
      ...prev,
      travel: props.travelParty
    })
    ) 
  },[props.travelParty])

  console.log(props.travelParty)

  return (
    <div className="accordian-checkbox">
          <Accordion sx={{minWidth: 600, margin:'1em'}} disabled={!checked}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>{props.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <p>Air Travel</p>
              <div className="flight-group">
                <TextField
                  id="input-with-icon-textfield"
                  onChange={handleTextInput}
                  name="departRoute"
                  label="Depart Route"
                  InputProps={{
                  startAdornment: (
                  <InputAdornment position="start">
                    <FlightTakeoffIcon />
                  </InputAdornment>
                    ),
                  }}
                  variant="standard"
                />
                <Input name="departDate" type="date" sx={{marginLeft: '3em'}} onChange={handleTextInput}/>
              </div>
              <div className="flight-group">
                <TextField
                  name="returnRoute"
                  id="input-with-icon-textfield"
                  label="Return Route"
                  onChange={handleTextInput}
                  InputProps={{
                  startAdornment: (
                  <InputAdornment position="start">
                    <FlightLandIcon />
                  </InputAdornment>
                    ),
                  }}
                  variant="standard"
                />
                <Input name="returnDate" type="date" sx={{marginLeft: '3em'}} onChange={handleTextInput}/>

              </div>
              <TextField name="prefTime" sx={{marginBottom: 2}}  id="outlined-disabled" label="Preferred Flight Time" onChange={handleTextInput}/>
              
              <p>Ground Travel</p>
              <TextField name="groundTravel" sx={{marginBottom: 2}} fullWidth  id="fullWidth" label="Ground travel details" onChange={handleTextInput}/>
              <p>Accommodation</p>
              <TextField name="accom" sx={{marginBottom: 2}} fullWidth  id="fullWidth" label="Accommodation required" onChange={handleTextInput}/>
            </AccordionDetails>
          </Accordion>
          <Checkbox sx={{alignSelf: 'center'}} name="craig" value={checked.craig || ''} checked={checked.craig} onChange={handleChange}></Checkbox>
        </div>

  )
}